export enum UserStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  BLOCKED = 'BLOCKED'
}

export const userStatusMapping: Record<UserStatusEnum, string> = {
  [UserStatusEnum.ACTIVE]: 'Active',
  [UserStatusEnum.INACTIVE]: 'Inactive',
  [UserStatusEnum.BLOCKED]: 'Blocked'
}

// Why an account is not active, stored by the backend (null while active)
export enum UserStatusReasonEnum {
  INACTIVITY = 'INACTIVITY',
  FAILED_ATTEMPTS = 'FAILED_ATTEMPTS',
  MANUAL = 'MANUAL'
}

export const userStatusReasonMapping: Record<UserStatusReasonEnum, string> = {
  [UserStatusReasonEnum.INACTIVITY]: 'Désactivé (inactivité)',
  [UserStatusReasonEnum.FAILED_ATTEMPTS]: 'Désactivé (tentatives échouées)',
  [UserStatusReasonEnum.MANUAL]: 'Désactivé (manuel)'
}
